<template>
  <div class="landing">
    <breadcrumb v-bind:path2="path2"></breadcrumb>
    <div class="landing-container">
      <div class="page-width" >
          <ul>
            <li v-for="(item, index) in allCategories"class="categories-container" @click="goToCategoryPage(item)">
              <div class="title-img-container">
                <h4 class="cat-title">{{item.Name}}</h4>
                <img class="cat-image" :src="item.Image" />
              </div>
              <p class="cat-desc">{{item.CategoryDescription}}</p>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import breadcrumb from '@/components/breadcrumb';
import landingPage from './landingPage';
import { mapActions, mapState, mapMutations } from 'vuex';
import {
  isUserAuthenticated,
  setLocalCart,
  getLocalCart
} from "../../store/modules/cart";
export default {
  name: 'landing',
  components: {
    breadcrumb,
  },
  props: {
    itemData: [],
  },
    metaInfo() {
    return {
    title: `Elegant Granite - Elegant Granite`,
    meta: [
        { name: 'description', content: `` },
        { name: 'keywords', content: "" },
        { name: 'robots', content: "index,follow" }
      ]
    }
  },
  data() {
    return {
      path2: this.$t('apoodrInc'),
      landingCategory: '',
      currentCategory: '',
      list: [],
    }
  },
  methods: {
    ...mapActions('search',['fetchProducts']),
    ...mapActions('products',['fetchCategories']),
    ...mapMutations('products', ['updateActiveLanding']),
    ...mapMutations('checkout', ['setPricesForCheckout', 'saveTotalPrice', 'saveGrandTotal', 'clearPromoCode', 'clearCard']),
    goToCategoryPage(cat) {
      this.updateActiveLanding(cat);
      this.$router.push({ path: `/${cat.Key}`})
    },
  },
    beforeRouteLeave(to, from, next) {
    if (isUserAuthenticated() && to.name === 'purchase') {
      this.$store.dispatch('cart/getCart')
      .then(() => {
        const cartItems = {};
        cartItems.SalesOrder_id = this.$store.state.cart.cartProductsList.SalesOrder_id;
        cartItems.Sales_Order_Lines = this.$store.state.cart.cartProductsList.Sales_Order_Lines;
        cartItems.ShippingMethod = "Delivery";
        cartItems.Tip = 0;
        cartItems.TipPercentage = 0;
        cartItems.TotalPrice =  this.$store.state.cart.cartProductsList.TotalPrice;
        this.$store.dispatch('cart/saveAndAdjustCart', cartItems)
        .then(() => {
          this.saveTotalPrice(this.necessaryCartItems.TotalPrice);
        })
      })
    }
    this.clearPromoCode();
    this.clearCard();
    next();
  },
  watch: {
    itemCount: function(newVal, oldVal) {
      if (newVal !== oldVal) {
        if (isUserAuthenticated()) {
          this.$store.dispatch('cart/getCart')
        } else {
          this.$store.dispatch('cart/fetchCartProducts')
        }
      }
    },
  },
  computed: mapState({
    groups: state => state.navbar.allGroups,
    allCategories() {
      let categories = [];
      this.groups.map(group => {
        group.Categories.map(category => {
          if (category.Name !== 'G' && category.Name !== 'H' && category.ProductCategory_id !== 9) {
            categories.push(category);
          }
        })
      })
      return categories;
    },
  }),
}
</script>

<style lang="less">
@import "../../assets/css/public.less";
@import "../../assets/css/landing.less";
</style>



// WEBPACK FOOTER //
// src/view/Footer/landing.vue